import React, { useState } from "react";
import Tree from "./Tree";

function TreeNode({ node, clickedFolder, activeFolder }) {
  const { children, document_name, document_uuid } = node;
  const [showChildren, setShowChildren] = useState(false);
  const handleClick = () => {
    setShowChildren(!showChildren);
    handleFolderClick(node);
  };

  const handleFolderClick = (data) => {
    clickedFolder(data);
  };

  return (
    <>
      <div
        onClick={handleClick}
        style={{ marginBottom: "10px", cursor: "pointer" }}
      >
        <span
          style={{
            fontWeight: activeFolder == document_uuid ? "bold" : "normal",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <i className="fas fa-folder" style={{ color: "#F1D592" }}></i>{" "}
          {document_name}
        </span>
      </div>
      <ul style={{ paddingLeft: "0px", borderLeft: "1px solid #F1D592" }}>
        {showChildren && (
          <Tree
            treeData={children}
            folderClicked={handleFolderClick}
            active={activeFolder}
          />
        )}
      </ul>
    </>
  );
}

export default TreeNode;
